import { GoogleRecaptchaDirective } from '@df/module-google-recaptcha/google-recaptcha.directive';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ButtonStyleComponent } from '../../common/buttons/button-style/button-style.component';
import { CheckboxComponent } from '../../common/form/checkbox/checkbox.component';
import { FormFieldComponent } from '../../common/form/field/form-field.component';
import { FormMuiFieldComponent } from '../../common/form/mui-field/form-mui-field.component';
import { RadioGroupItemComponent } from '../../common/form/radio/group/item/radio-group-item.component';
import { RadioGroupComponent } from '../../common/form/radio/group/radio-group.component';
import { ResultComponent } from '../../common/result/result.component';
import { FileInputComponent } from '../../ui/form/file-input/file-input.component';
import { AbstractLocalCustomformComponentDef } from './abstract-local-customform.component.def';
import { CustomformAddressFieldsetComponent } from './address-fieldset/customform-address-fieldset.component';

@Component({
    selector: 'customform',
    standalone: true,
    imports: [
        CustomformAddressFieldsetComponent,
        ButtonStyleComponent,
        CheckboxComponent,
        FormFieldComponent,
        FormMuiFieldComponent,
        FormsModule,
        NgClass,
        RadioGroupComponent,
        RadioGroupItemComponent,
        ResultComponent,
        TranslationModule,
        FileInputComponent,
        GridModule,
        GoogleRecaptchaDirective
    ],
    templateUrl: './customform.html',
    styleUrl: './customform.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomformComponent extends AbstractLocalCustomformComponentDef {}
